module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcAgMAAAAPYzcHAAAADFBMVEUAAAAAfu4Afe0AfO2nynzaAAAAA3RSTlMASePizoNQAAAAMklEQVQI12NgIATy/wPBTwaG/SD6H4KGiRMB8qHq9oP0IdH5ROnPh9qzH2IvnM4nxn4A+cAyv9xv1T8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourseImages/y-2@2x.png
// module id = Q1rC
// module chunks = 96